module.exports = __webpack_public_path__ + "static/img/search_subcat_item_01_show.2ebcd14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/search_subcat_item_01_show.jpg
// module id = K326
// module chunks = 0